import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2yfoe3nc8k: FaireBrandEntity = {
  token: "b_2yfoe3nc8k",
  type: "brand",
  name: "Papermoon",
  avatarUrl:
    "https://cdn.faire.com/fastly/949aabb1c9fc0e18a971eeaef17ba4a46324c048b7e46e1448e1b73ae799f3d7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4928b4962193ab3621e11f7880d60dc23e2d7b543a0070c8762a66ecbb8645c2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/949aabb1c9fc0e18a971eeaef17ba4a46324c048b7e46e1448e1b73ae799f3d7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4928b4962193ab3621e11f7880d60dc23e2d7b543a0070c8762a66ecbb8645c2.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 146,
  isInsider: true,
  description:
    "Launched in 2012, Papermoon offers some of the most unique and stylish women's clothing at great, affordable prices. Our style appeals to girls and young women who are youthful, spontaneous, vibrant and fashionable and love to express themselves through what they wear. We all deserve to look beautiful, and it is our hope that our clothes will help bring out the confidence and beauty that is in every girl and woman.\n\nWe are extremely passionate in what we do and we will always strive for excellence in all aspects of design, production, distribution and customer service.\n\nWe hope to hear from you soon!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:09.281Z",
    importedBy: "entity-db-cli",
  },
};
